import { environment } from '../../../environments/environment';

export const API_CONFIG = {
  /** Relative URL — proxied via dev server when running locally */
  baseUrl: environment.api.baseUrl,

  /** Auth server (absolute — used for full-page redirects & native form POST) */
  authServerUrl: environment.api.authServerUrl,

  /** Token endpoint — relative, goes through proxy (avoids CORS on XHR) */
  oauth2TokenUrl: environment.api.oauth2TokenUrl,

  /** OAuth2 client credentials (registered in the auth server DB) */
  clientId: environment.api.clientId,
  clientSecret: environment.api.clientSecret,

  /** Where the auth server redirects after issuing an authorization code */
  redirectUri: environment.api.redirectUri,

  /** Scopes to request */
  scopes: environment.api.scopes,

  /** URL of the main application */
  gestionUrl: environment.api.gestionUrl,
} as const;
